import React, { useState, useEffect, useRef, useMemo } from "react";
import "@styles/pages/EarnSDollar/EarnSDollar.scss";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, LinearProgress } from "@mui/material";
import EarnSDollarForm from "@pages/EarnSDollar/step1/EarnSDollarForm";
import ThankYouPage from "@pages/GenericPage/ThankYouPage";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { resetFormStep } from "@store/ui/formStepSlice";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import { redirectToSamsungLoginPage } from "@utils/redirectToSamsungLoginPage";

const EarnSDollar = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.formStep.earnSDollar);
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );

  //pop up 2025-09-18
  const [redirectToLinkUpProgress, setRedirectToLinkUpProgress] = useState(0);
  const redirectedRef = useRef(false);
  const accessToken = localStorage.getItem("access_token");
  const host = window.location.hostname;
  const index = useMemo(() => {
    if (host === "localhost") {
      return "LocalSALinkUp";
    } else {
      return "SALinkUp";
    }
  }, []);

  useEffect(() => {
    if (memberInfoData?.member_type == 1) {
      setRedirectToLinkUpProgress(0);
      redirectedRef.current = false;
      const timer = setInterval(() => {
        setRedirectToLinkUpProgress((old) => {
          const next = Math.min(old + Math.random() * 5, 100);

          if (next === 100 && !redirectedRef.current) {
            redirectedRef.current = true;
            redirectToSamsungLoginPage({
              memberInfoData,
              accessToken,
              index,
            });
          }
          return next;
        });
      }, 100);

      return () => {
        clearInterval(timer);
        setRedirectToLinkUpProgress(0);
        redirectedRef.current = false;
      };
    }
  }, []);

  useEffect(() => {
    dispatch(resetFormStep({ formKey: "earnSDollar" }));
  }, []);

  useEffect(() => {
    if (currentStep === 1) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [currentStep]);

  return (
    <Box className="earn-s-dollar-container">
      {memberInfoData?.member_type == 1 ? (
        <Box className="earn-notice-container">
          <Box className="earn-icon-container">
            <img
              className="earn-logo"
              src={`${process.env.PUBLIC_URL}/assets/images/global/mobile_logo.png`}
              alt="logo"
            />
          </Box>
          <Typography className="earn-title">
            {memberInfoData?.first_name},<br />
            <Trans i18nKey="popup:after_login_before_link_sa_title" />{" "}
            <LinearProgress
              variant="determinate"
              value={redirectToLinkUpProgress}
              className="custom-progress"
            />
          </Typography>
        </Box>
      ) : (
        <>
          {" "}
          {currentStep === 0 && (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <EarnSDollarForm />
            </LocalizationProvider>
          )}
          {currentStep === 1 && (
            <ThankYouPage
              title={t("s_dollar:thank_you_message_title")}
              textList={[t("s_dollar:thank_you_message_description")]}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default EarnSDollar;
